import React, { FC } from 'react'
import Page from '../components/Page'
import NavigationArrow from '../components/NavigationArrow'
import { useHistory } from 'react-router-dom'
import { PageURLs } from '../common'
import BlueCase from '../images/blue-case.svg'
import Icons from '../components/Icons'
import { useDispatch } from 'react-redux'
import {
  startNewTransferWithSameRequirements,
  startReverseTransfer,
  startFromDestinationAirport,
} from '../store/slices/app'

const AddTransfer: FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const startFreshJourney = () => {
    dispatch(startNewTransferWithSameRequirements())
    history.push(PageURLs.BookNow)
  }

  const startTransferFromDestinationAirport = () => {
    dispatch(startFromDestinationAirport())
    history.push(PageURLs.BookNow)
  }

  const startWithReverseJourney = () => {
    dispatch(startReverseTransfer())
    history.push(PageURLs.BookNow)
  }

  return (
    <Page className="add-transfer__page">
      <section>
        <NavigationArrow onClick={() => history.push(PageURLs.CompleteBooking)} />
        <img src={BlueCase} alt="" className="d-md-none add-transfer__suitcase" />
      </section>

      <section className="add-transfer__inner">
        <h1 className="h3 add-transfer__title">What other transfer would you like to add?</h1>

        <nav className="navigation-list__wrapper">
          <button className="navigation-list__item" onClick={startWithReverseJourney}>
            <span>Same journey in reverse</span>
            <Icons.Arrow />
          </button>
          <button className="navigation-list__item" onClick={startTransferFromDestinationAirport}>
            <span>Transfer from destination airport</span>
            <Icons.Arrow />
          </button>
          <button className="navigation-list__item" onClick={startFreshJourney}>
            <span>Different journey</span>
            <Icons.Arrow />
          </button>
        </nav>
      </section>

      <div className="d-none d-md-block add-transfer__suitcase-wrapper">
        <img src={BlueCase} alt="" className="add-transfer__suitcase" />
      </div>
    </Page>
  )
}

export default AddTransfer
